<template>
  <v-card class="card-container">
    <v-dialog v-model="addModal" :key="addModalKey" max-width="750">
      <v-card>
        <div class="px-7 pt-7 pb-4">
          <div class="text-center">
            <h1 class="mb-4">Adicionar Oficina</h1>
          </div>
          <v-form class="form" ref="addForm" lazy-validation>
            <v-row class="ma-0" dense>
              <v-col cols="12" sm="12">
                <label>{{ $t('Nome') }}</label>
                <v-text-field
                  class="primary-input"
                  hide-details="auto"
                  v-model="selectedWorkshop.name"
                  :rules="[(v) => !!v || 'Campo obrigatório!']"
                  required
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                class="ma-0 rounded-lg mb-4"
                style="background: #f5f5f5"
              >
                <div class="d-flex align-center px-1">
                  <label class="label"> Atividades: </label>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    class="primary-button ml-4"
                    @click="addNewActivities"
                  >
                    Adicionar Atividade
                  </v-btn>
                </div>

                <div
                  class="d-flex align-center ma-4"
                  v-for="(activity, index) in selectedWorkshop.activities"
                  :key="activity.id"
                >
                  <v-text-field
                    hide-details="auto"
                    v-model="activity.title"
                    :readonly="!!activity.id"
                    placeholder="Insira o nome da atividade"
                    class="primary-input"
                    outlined
                  >
                    <template #message="{ message }"> {{ message }} </template>
                  </v-text-field>

                  <v-btn
                    depressed
                    class="ml-2 mb-4"
                    color="error"
                    text
                    icon
                    @click="removeActivityCreate(index)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
          <div class="text-center">
            <v-btn
              depressed
              class="primary-button ml-1 ma-1"
              text
              @click="addModal = false"
            >
              {{ $t('Cancelar') }}
            </v-btn>

            <v-btn depressed class="secondary-button ma-1" text @click="add">
              Adicionar
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editModal" :key="editModalKey" max-width="750">
      <v-card>
        <div class="px-7 pt-7 pb-4">
          <div class="text-center">
            <h1 class="mb-4">Atualizar Oficina</h1>
          </div>
          <v-form class="form" ref="editForm" lazy-validation>
            <v-row class="ma-0" dense>
              <v-col cols="12" sm="12">
                <label>{{ $t('Nome') }}</label>
                <v-text-field
                  class="primary-input"
                  hide-details="auto"
                  v-model="selectedWorkshop.name"
                  :rules="[(v) => !!v || 'Campo obrigatório!']"
                  required
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                class="ma-0 rounded-lg mb-4"
                style="background: #f5f5f5"
              >
                <div class="d-flex align-center px-1">
                  <label class="label"> Atividades: </label>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    class="primary-button ml-4"
                    @click="addNewActivities"
                  >
                    Adicionar Atividade
                  </v-btn>
                </div>

                <div
                  class="d-flex align-center ma-4"
                  v-for="(activity, index) in selectedWorkshop.activities"
                  :key="activity.id"
                >
                  <v-text-field
                    hide-details="auto"
                    v-model="activity.title"
                    :readonly="!!activity.id"
                    placeholder="Insira o nome da atividade"
                    class="primary-input"
                    outlined
                  >
                    <template #message="{ message }"> {{ message }} </template>
                  </v-text-field>

                  <v-btn
                    depressed
                    class="ml-2 mb-4"
                    color="error"
                    text
                    icon
                    @click="removeActivityCreate(index)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
          <div class="text-center">
            <v-btn
              depressed
              class="primary-button ml-1 ma-1"
              text
              @click="editModal = false"
            >
              {{ $t('Cancelar') }}
            </v-btn>

            <v-btn depressed class="secondary-button ma-1" text @click="edit">
              Atualizar
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeModal" max-width="350">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja remover esta oficina? Esta ação é
            irreversível.
          </div>

          <v-btn
            depressed
            class="ma-1"
            color="grey"
            text
            @click="removeModal = false"
          >
            Cancelar
          </v-btn>

          <v-btn class="ma-1" color="error" text @click="remove()">
            {{ $t('Remover') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="main-toolbar">
      <div class="icon-back">
        <v-icon id="icon" size="37" color="white"> mdi-clipboard-text </v-icon>
      </div>

      <span class="main-toolbar-title">{{ $t('Oficinas') }}</span>

      <v-spacer></v-spacer>
      <div class="d-flex justify-end my-1">
        <v-text-field
          v-model="filter.name"
          :placeholder="$t('Pesquisar por nome')"
          outlined
          class="primary-input"
          hide-details
          style="max-width: 300px"
        ></v-text-field>
        <v-btn depressed dark class="mx-2 primary-button" @click="list">
          {{ $t('Filtrar') }}
        </v-btn>
      </div>
    </div>

    <div>
      <div class="d-flex justify-end align-center">
        <v-checkbox
          v-model="alphabeticalOrder"
          label="Ordenar Alfabeticamente"
          hide-details
          class="mt-0 mr-4"
          @change="toggleAlphabeticalOrder"
        ></v-checkbox>

        <v-btn
          depressed
          dark
          class="mr-2 secondary-button"
          @click="
            ;(selectedWorkshop = {}),
              (addKey = !addKey),
              (addModal = true),
              (addModalKey = !addModalKey)
          "
        >
          Adicionar Oficina
        </v-btn>
      </div>

      <v-expansion-panels focusable class="mt-8">
        <draggable
          v-model="displayedItems"
          :disabled="alphabeticalOrder"
          @end="onDragEnd"
          handle=".drag-handle"
          tag="div"
          style="width: 100%"
        >
          <v-expansion-panel
            v-for="workshop in displayedItems"
            :key="workshop.id"
          >
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <div class="d-flex align-center" style="width: 100%">
                  <v-icon
                    v-if="!alphabeticalOrder"
                    class="drag-handle mr-3"
                    style="cursor: move"
                  >
                    mdi-drag-vertical
                  </v-icon>
                  <span style="flex: 1">{{ workshop.name }}</span>
                  <div class="d-flex justify-end pt-4">
                    <v-btn
                      v-if="open"
                      depressed
                      class="primary-button ml-1"
                      @click.stop="addNewActivityToWorkshop(workshop)"
                    >
                      Adicionar Atividade
                    </v-btn>

                    <v-btn
                      v-else
                      depressed
                      class="primary-button ml-1"
                      @click="addNewActivityToWorkshop(workshop)"
                    >
                      Adicionar Atividade
                    </v-btn>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          depressed
                          class="ml-2 mb-4"
                          text
                          icon
                          @click.stop="openEdit(workshop)"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Oficina</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          depressed
                          class="mb-4"
                          color="error"
                          text
                          icon
                          @click.stop="openDelete(workshop.id)"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir Oficina</span>
                    </v-tooltip>
                  </div>
                </div>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div class="mt-3">
                <span for="Atividades" class="label"> Atividades: </span>
              </div>
              <v-spacer></v-spacer>
              <span
                class="d-flex justify-center"
                v-if="workshop.activities && workshop.activities.length == 0"
              >
                <span>Nenhuma atividade encontrada</span>
              </span>
              <div
                v-for="(activity, index) in workshop.activities"
                :key="index"
              >
                <v-form
                  :ref="`acitvityform${index}`"
                  class="d-flex align-center ma-4"
                >
                  <v-text-field
                    hide-details="auto"
                    v-model="activity.title"
                    placeholder="Insira o nome da atividade"
                    class="primary-input"
                    outlined
                    :disabled="activity.id != null"
                  >
                    <template #message="{ message }">
                      {{ message }}
                    </template>
                  </v-text-field>

                  <v-btn
                    depressed
                    class="ml-2 mb-4"
                    color="error"
                    text
                    icon
                    @click="removeActivity(index, workshop)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="activity.id == null"
                    depressed
                    class="ml-2 mb-4"
                    text
                    icon
                    @click="addActivityToExistingWorkshop(index, workshop)"
                  >
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                </v-form>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </draggable>
      </v-expansion-panels>

      <div class="pagination">
        <div class="item-pagination block-one">
          <div class="registros" v-if="items.length">
            <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
            <br />
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="filter.page"
            :length="filter.totalPages"
            :total-visible="5"
          ></v-pagination>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import draggable from 'vuedraggable'

export default {
  name: 'WorkshopPage',

  components: {
    draggable,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.filter.institutionId = this.institutionId
    this.list()
  },

  data() {
    return {
      institutionId: null,
      loading: false,
      selectedWorkshop: {
        name: '',
        activities: [],
      },
      apiService: new ApiService(),
      addKey: new Date() + 1,
      addModal: false,
      editModal: false,
      removeModal: false,
      user: {},
      filter: {
        page: 1,
        pageSize: 15,
      },
      items: [],
      customOrder: [],
      alphabeticalOrder: false,
      headers: [
        {
          text: 'Nome',
          align: 'center',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Ações',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      expandedItems: [],
      activity: null,
      updatedActivities: [],
      addModalKey: new Date() + 2,
      editModalKey: new Date() + 3,
      selectedActivityItem: {
        workshopId: null,
        activityTitle: '',
      },
    }
  },

  computed: {
    displayedItems: {
      get() {
        if (this.alphabeticalOrder) {
          return [...this.items].sort((a, b) =>
            a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
          )
        } else {
          return [...this.items].sort((a, b) => {
            if (a.displayOrder != null && b.displayOrder != null) {
              return a.displayOrder - b.displayOrder
            }
            if (a.displayOrder != null) return -1
            if (b.displayOrder != null) return 1
            return a.id - b.id
          })
        }
      },
      set(value) {
        if (!this.alphabeticalOrder) {
          this.customOrder = value
        }
      },
    },
  },

  methods: {
    list() {
      this.apiService.get('workshop/paginate', this.filter).then((response) => {
        this.items = response.content.data
        const pager = response.content.pager
        this.filter.page = pager.currentPage
        this.filter.pageSize = pager.pageSize
        this.filter.totalItems = pager.totalItems
        this.filter.totalPages = pager.totalPages
      })
    },

    toggleAlphabeticalOrder() {},

    onDragEnd() {
      this.saveOrderToDatabase()
    },

    saveOrderToDatabase() {
      this.loading = true

      const orderedIds = this.customOrder.map((workshop, index) => ({
        id: workshop.id,
        displayOrder: index,
      }))

      this.apiService
        .put('workshop/update-order', { workshops: orderedIds })
        .then(() => {
          this.$toast.success('Ordem atualizada com sucesso!')
          this.loading = false
          this.list()
        })
        .catch((error) => {
          this.loading = false
          this.$toast.error('Erro ao atualizar a ordem das oficinas.')
          console.error('Erro ao salvar ordem:', error)
          this.list()
        })
    },

    openEdit(item) {
      this.selectedWorkshop = { ...item }
      this.editModal = true
    },

    openDelete(id) {
      console.log(id)
      this.selectedWorkshop.id = id
      this.removeModal = true
    },

    add() {
      if (this.$refs.addForm.validate()) {
        this.selectedWorkshop.institutionId = this.institutionId
        this.loading = true

        const workshopPayload = {
          name: this.selectedWorkshop.name,
          institutionId: this.selectedWorkshop.institutionId,
          activities: this.selectedWorkshop.activities
            ? this.selectedWorkshop.activities.map((activity) => ({
                title: activity.title,
              }))
            : null,
        }

        this.apiService
          .post('workshop', workshopPayload)
          .then(() => {
            this.addModal = false
            this.loading = false
            this.$toast.success('Oficina e atividades cadastradas com sucesso!')
            this.list()
            this.selectedWorkshop.activities = []
          })
          .catch(() => {
            this.loading = false
            this.$toast.error('Erro ao cadastrar a oficina.')
          })
      }
    },

    addNewActivities() {
      if (!this.selectedWorkshop) {
        this.selectedWorkshop = {}
      }

      if (!Array.isArray(this.selectedWorkshop.activities)) {
        this.selectedWorkshop.activities = []
      }

      this.selectedWorkshop.activities.push({
        title: '',
      })

      this.$forceUpdate()
    },

    removeActivityCreate(index) {
      this.selectedWorkshop.activities.splice(index, 1)
      this.$forceUpdate()
    },

    edit() {
      this.selectedWorkshop.institutionId = this.institutionId
      this.loading = true

      const workshopPayload = {
        id: this.selectedWorkshop.id,
        name: this.selectedWorkshop.name,
        institutionId: this.selectedWorkshop.institutionId,
        activities: this.selectedWorkshop.activities,
      }

      this.apiService
        .put('workshop', workshopPayload)
        .then(() => {
          this.list()
          this.loading = false
          this.editModal = false
          this.$toast.success('Oficina atualizada com sucesso!')
        })
        .catch(() => {
          this.loading = false
          this.$toast.error('Erro ao atualizar a oficina.')
        })
    },

    remove() {
      this.loading = true
      const selectedWorkshopId = this.selectedWorkshop.id
      this.apiService
        .delete(`workshop/${selectedWorkshopId}`)
        .then(() => {
          this.list()
          this.loading = false
          this.removeModal = false
          this.$toast.success('Oficina removida com sucesso!')
        })
        .catch(() => {
          this.loading = false
        })
    },

    addActivity() {
      if (this.activity && this.activity.trim() !== '') {
        this.selectedWorkshop.activities.push({ title: this.activity.trim() })
        this.activity = ''
      }
    },

    addNewActivityToWorkshop(workshop) {
      if (!workshop.activities) {
        this.$set(workshop, 'activities', [])
      }

      workshop.activities.push({
        title: '',
        id: null,
      })

      this.$forceUpdate()
    },

    addActivityToExistingWorkshop(index, workshop) {
      this.selectedWorkshop = { ...workshop }

      const activity = this.selectedWorkshop.activities[index]

      if (!activity.title || activity.title.trim() === '') {
        this.$toast.error('A atividade precisa ter um nome.')
        return
      }

      if (!activity.id) {
        delete activity.id
      }

      this.selectedWorkshop.activities[index] = { ...activity }

      this.apiService
        .put('workshop', this.selectedWorkshop)
        .then(() => {
          this.$toast.success('Atividade adicionada com sucesso!')
          this.list()
        })
        .catch(() => {
          this.$toast.error('Erro ao adicionar a atividade.')
        })
    },

    removeActivity(index, workshop) {
      this.selectedWorkshop = { ...workshop }
      this.selectedWorkshop.activities.splice(index, 1)

      this.apiService
        .put('workshop', this.selectedWorkshop)
        .then(() => {
          this.$toast.success('Atividade removida com sucesso!')
          this.list()
        })
        .catch(() => {
          this.$toast.error('Erro ao remover oficina')
        })
    },
  },
}
</script>

<style scoped>
.topper-espansion {
  background-color: #4c6d97;
  display: flex;
  min-height: 48px;
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 0 28px 0 28px;
}
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.drag-handle {
  opacity: 0.6;
  transition: opacity 0.2s;
}
.drag-handle:hover {
  opacity: 1;
}
</style>
